import React from "react";
import * as Icons from "lucide-react";

// Custom icon (message-circle-question-mark) - not in lucide-react 0.263.1
const MessageCircleQuestionMarkIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-message-circle-question-mark"
    aria-hidden="true"
    {...props}
  >
    <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <path d="M12 17h.01" />
  </svg>
);

const CUSTOM_ICONS = { MessageCircleQuestionMark: MessageCircleQuestionMarkIcon };

export function Icon({
  name,
  size,
  color,
  strokeWidth,
  className,
  decorative = true,
  "aria-label": ariaLabel
}) {
  const CustomIcon = CUSTOM_ICONS[name];
  const LucideIcon = !CustomIcon && Icons[name];

  if (!CustomIcon && !LucideIcon) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  if (!decorative && !ariaLabel) {
    throw new Error("Non-decorative icons must have an aria-label");
  }

  const IconComponent = CustomIcon || LucideIcon;

  return (
    <span
      className={["icon", className].filter(Boolean).join(" ")}
      role={decorative ? undefined : "img"}
      aria-hidden={decorative ? true : undefined}
      aria-label={decorative ? undefined : ariaLabel}
      style={{
        ...(size ? { "--icon-size": typeof size === "number" ? `${size}px` : size } : {}),
        ...(color ? { "--icon-color": color } : {}),
        ...(strokeWidth ? { "--icon-stroke": strokeWidth } : {})
      }}
    >
      <IconComponent aria-hidden="true" />
    </span>
  );
} 